import { createSlice } from "@reduxjs/toolkit";
import { jwtDecode } from "jwt-decode"; // Fix import

const getStoredToken = () => {
  try {
    return localStorage.getItem("jwtToken");
  } catch {
    return null;
  }
};

const decodeStoredUser = (token) => {
  if (!token) return null;

  try {
    return jwtDecode(token);
  } catch {
    try {
      localStorage.removeItem("jwtToken");
    } catch {
      // Ignore storage cleanup errors so the app can still render.
    }

    return null;
  }
};

const token = getStoredToken();
const user = decodeStoredUser(token);

const initialState = {
  isAuthenticated: !!user, // Properly set to true/false
  user,
  token: user ? token : null,
};

const userSlice = createSlice({
  name: "auth", // Make sure the name matches in the store
  initialState,
  reducers: {
    loginSuccess: (state, action) => {
      state.user = action.payload.user;
      state.token = action.payload.token;
      state.isAuthenticated = true;
      localStorage.setItem("jwtToken", action.payload.token);
    },
    logout: (state) => {
      state.user = null;
      state.token = null;
      state.isAuthenticated = false;
      localStorage.removeItem("jwtToken");
    },
  },
});

export const { loginSuccess, logout } = userSlice.actions;
export default userSlice.reducer;
